import List from "@/components/list";

const Table = args => {

  const LeaveStartTime = ({ props: { vo } }) => {
    return <span>{vo.row.leaveStartTimeName || "--"}</span>;
  };
  const LeaveEndTime = ({ props: { vo } }) => {
    return <span>{vo.row.leaveEndTimeName || "--"}</span>;
  };
  const LeaveDays = ({ props: { vo } }) => {
    return <span>{vo.row.leaveDays || "--"}</span>;
  };
  const AuditNotes = ({ props: { vo } }) => {
    return <span>{vo.row.remarks || "--"}</span>;
  };
  const FinishTime = ({ props: { vo } }) => {
    return <span>{vo.row.finishTime || "--"}</span>;
  };
  const CreateDate = ({ props: { vo } }) => {
    return <span>{vo.row.createDate || "--"}</span>;
  };

  const AccountTableConfig = [
    {
      label: "姓名",
      prop: "userName",
      width: "100",
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      width: "120"
    },{
      label: "开始时间",
      prop: "leaveStartTimeName",
      width: "120",
      render: (vo) => <LeaveStartTime vo={vo} />,
    },{
      label: "结束时间",
      prop: "leaveEndTimeName",
      width: "120",
      render: (vo) => <LeaveEndTime vo={vo} />,
    },{
      label: "时长（天）",
      prop: "leaveDays",
      width: "100",
      render: (vo) => <LeaveDays vo={vo} />,
    },{
      label: "申请事由",
      prop: "remarks",
      width: "140",
      render: (vo) => <AuditNotes vo={vo} />,
      showOverflowTooltip: true
    },{
      label: "更新时间",
      prop: "createDate",
      width: "150",
      render: (vo) => <FinishTime vo={vo} />
    }
  ];
  if (args.props.leaveType == 1) {
    AccountTableConfig.splice(5, 0, {
      label: "请假类型",
      prop: "leaveTypeName",
      width: "140"
    });
    AccountTableConfig.splice(7, 1, {
      label: "提交时间",
      prop: "createDate",
      width: "150",
      render: (vo) => <CreateDate vo={vo} />
    });
  }
  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
